import { create } from "zustand";

export const useDeleteAccountModal = create((set) => ({
	isOpen: false,
	onOpen: () => set({ isOpen: true }),
	onClose: () => set({ isOpen: false }),
	data: {},
}));
